// extracted by mini-css-extract-plugin
export default {"container":"aiConversations_container__WlXtI","newQuizzesContainer":"aiConversations_newQuizzesContainer__ZvJyB","textDraw":"aiConversations_textDraw__kbbIP"};